<template>
  <div style="background-color: #ffffff; min-height: 100vh; box-sizing: border-box">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <div class="top-left">
        <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'" alt="" class="avatar" />
      </div>
      <div class="top-center">
        <div class="username-row">
          <div class="username">{{ $store.state.userInfo.username || $store.state.userInfo.userid || $store.state.userInfo.id || $store.state.userInfo.user_id || $store.state.userInfo.account || $store.state.userInfo.name || $store.state.userInfo.nickname || $store.state.userInfo.user_name || '' }}</div>
          <div class="right-buttons">
            <div class="settings-btn" @click="$parent.goNav('/userInfo')">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAARVBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////9X1DS3AAAAFnRSTlMAGS/foQqV7bPpd77Q+KjIWkuehmc9s4NUtAAAARhJREFUOMuNlFkShCAMRAPI5gau9z/qOAQLGIhO/yDyKiakI8BXrDfCJg3Q1DadhURxejBch/NHY0HFbUWdOqOWa79eax8jmCSVKB8OO5BhHXg76x1j9BiMKO3+0gJgrmVibxQIOtiG1PF91rGSWgqrxqwtha05FbCuQc3YjztrAjMlRWDYmVHCIzYGymVvGphEqrimGmMiUAZ33Hu/NDBmAzXnFcsK4zpQKr9kXWF8Kqk2dmAbN3jElttej1g04Q6PmMS8PDxjmL+HNww4WvUNg90Dja1AK2L6P0ykLjfVXec2DqCkMY3G63M7EON19Y6hbdoDzXAIWRpaZ2o5bMuaGZ+WKKxPUqwc8Lbm7Ba4clbXsk7Ff8MHTt0sQUfXju4AAAAASUVORK5CYII=" alt="设置" class="settings-icon" />
              <span>{{ $t('settings') }}</span>
            </div>
            <img src="/static/image/message-icon.png" alt="消息" class="message-icon" @click="$parent.goNav('/message')">
          </div>
        </div>
        <div class="days">{{ $t('join_days') }}{{ $store.state.userInfo.joinday || 0 }}{{ $t('days') }}</div>
      </div>
    </div>
    
    <!-- 余额区域 -->
    <div class="balance-section">
      <div class="balance-info">
        <div class="balance-label">{{ $t('balance') }}</div>
        <div class="balance-amount">
          <span>U</span>{{ Math.floor($store.state.userInfo.balance || 0) }}
          <img :class="{ 'rotate': isRefreshing }" @click="refreshBalance" src="/static/style/sx.png" alt="reload" class="refresh-icon" />
        </div>
      </div>
      <div class="balance-buttons">
        <button class="deposit-btn" @click="$parent.goNav('/recharge')">
          <img src="/static/images/cz.webp" alt="" class="btn-icon" />
          <span>{{ $t('recharge') }}</span>
        </button>
        <button class="withdraw-btn" @click="$parent.goNav('/withdrawal')">
          <img src="/static/images/tx.webp" alt="" class="btn-icon" />
          <span>{{ $t('withdrawal') }}</span>
        </button>
      </div>
    </div>
    
    <!-- VIP等级区域 -->
    <div class="vip-section">
      <div class="vip-info">
        <div class="vip-level">{{ $t('current_vip') }}{{ $store.state.userInfo.vip || 0 }}</div>
        <div class="growth-value">{{ $t('vip') }}{{ vipTab }}{{ $t('growth_value') }} {{ userStats.flow || 0 }}/{{ currentVipFlow  || 0 }}</div>
      </div>
      <div class="vip-progress">
        <div class="vip-progress-bar">
          <div class="vip-progress-fill" :style="{ width: (vipProgress || 0) + '%' }"></div>
        </div>
      </div>
      <div class="vip-tabs">
        <div class="vip-tab" @click="$parent.goNav('/vip')">{{ $t('promotion_gift') }}</div>
        <div class="vip-tab" @click="$parent.goNav('/vip')">{{ $t('monthly_redpacket') }}</div>
        <div class="vip-tab" @click="$parent.goNav('/vip')">{{ $t('weekly_redpacket') }}</div>
        <div class="vip-tab" @click="$parent.goNav('/vip')">{{ $t('exclusive_activity') }}</div>
      </div>
    </div>
    
    <!-- 功能按钮区 -->
    <div class="function-section">
      <div class="function-grid">
        <div class="function-item" @click="$parent.goNav('/transRecord')">
          <img src="/static/images/zjmx.webp" alt="资金明细" class="function-icon" />
          <span>{{ $t('fund_detail') }}</span>
        </div>
        <div class="function-item" @click="$parent.goNav('/betRecord')">
          <img src="/static/images/tzjl.webp" alt="投注记录" class="function-icon" />
          <span>{{ $t('bet_record') }}</span>
        </div>
        <div class="function-item" @click="$parent.goNav('/userCent')">
          <img src="/static/images/grbb.webp" alt="个人报表" class="function-icon" />
          <span>{{ $t('personal_report') }}</span>
        </div>
        <div class="function-item" @click="$parent.goNav('/fanshui')">
          <img src="/static/images/yhhd.png" alt="返水" class="function-icon" />
          <span>{{ $t('rebate') }}</span>
        </div>		
        <div class="function-item" @click="$parent.goNav('/welfare')">
          <img src="/static/images/yhhd.png" alt="优惠活动" class="function-icon" />
          <span>{{ $t('promotions') }}</span>
        </div>
        <div class="function-item" @click="$parent.goNav('/shareMoney')">
          <img src="/static/images/fx.png" alt="分享赚钱" class="function-icon" />
          <span>{{ $t('share_earn') }}</span>
        </div>
        <div class="function-item" @click="$parent.goNav('/agentCenter')">
          <img src="/static/images/dl.webp" alt="代理中心" class="function-icon" />
          <span>{{ $t('agent_center') }}</span>
        </div>
		       <div class="function-item" @click="$parent.goNav('/about')">
          <img src="/static/images/gywm.webp" alt="关于我们" class="function-icon" />
          <span>{{ $t('about_us') }}</span>
        </div>
      </div>
    </div>
    
    <!-- 新人福利中心 -->
    <div class="welfare-section" @click="$parent.goNav('/welfare')">
      <div class="welfare-content">
        <div class="welfare-text">
          <div class="welfare-title"></div>
          <div class="welfare-subtitle"></div>
        </div>
        <div class="welfare-button"></div>
      </div>
    </div>
    
    <!-- 底部菜单 -->
   <!--  <div class="bottom-menu">
      <div class="menu-item" @click="$parent.goNav('/about')">
        <img src="/static/images/gy.webp" alt="关于我们" class="menu-icon" />
        <span>{{ $t('about_us') }}</span>
        <img src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" class="menu-arrow" />
      </div>
    </div>  -->
    
    <!-- 底部导航栏 -->
    <Foot />
  </div>
</template>
<script>
import Foot from '../libs/Foot';
export default {
  name: 'mine',
  components: {
    Foot
  },
  data() {
    return {
      isRefreshing: false,
      vipProgress: 0,
      vipGrowth: 0,
      vipTarget: 63000,
      vipTab: 3,
      userStats: {
        flow: 0
      },
      currentVipFlow: 0
    };
  },
  created() {
    let that = this;
    if (that.$store.state.token && that.$store.state.userInfo.vip) {
      that.vipTab = parseInt(that.$store.state.userInfo.vip) || 3;
    }
    that.getUserInfo();
    that.refreshBalance();
    that.uservip();
    that.getUserRealData();
  },
  methods: {
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length);
          userInfo.vip = vip;
          that.vipTab = parseInt(vip) || 3;
          
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
          console.log('用户信息已获取:', userInfo);
        }
      }).catch(err => {
        console.error('获取用户信息失败:', err);
      });
    },
    refreshBalance() {
      let that = this;
      if (that.isRefreshing) return;
      that.isRefreshing = true;
      console.log('刷新余额...');
      that.$apiFun.post('/api/balance', {}).then(res => {
        console.log('余额刷新接口返回:', res);
        if (res.code == 200 && res.data && res.data.balance !== undefined) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
          userInfo.balance = res.data.balance;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
          console.log('余额已刷新:', userInfo.balance);
        }
      }).catch(err => {
        console.error('刷新余额失败:', err);
      }).finally(() => {
        that.isRefreshing = false;
      });
    },
    uservip() {
      let that = this;
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code == 200) {
            if (res.data[that.vipTab - 1]) {
              that.currentVipFlow = res.data[that.vipTab - 1].flow || 30000;
            }
          }
        })
        .catch(res => {
          console.log('获取 VIP 数据失败:', res);
        });
    },
    getUserRealData() {
      let that = this;
      
      that.$apiFun
        .post('/api/game/users', {})
        .then(res => {
          if (res.code == 200 && res.data) {
            const userData = res.data.find(user => user.id == that.$store.state.userInfo.id) || {};
            
            that.userStats = {
              deposit: userData.recharge || userData.deposit || userData.total_recharge || that.userStats.deposit,
              flow: userData.flow || userData.bet || userData.total_bet || userData.total_flow || that.userStats.flow,
              growth: userData.growth || userData.exp || userData.experience || that.userStats.growth,
              maxGrowth: that.userStats.maxGrowth
            };
          }
        })
        .catch(res => {
          console.log('获取会员列表数据失败:', res);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// 顶部导航栏
.top-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 20px;
  background-color: #054dc4;
  color: white;
  
  .top-left {
    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 1px solid white;
    }
  }
  
  .top-center {
    flex: 1;
    margin-left: 15px;
    
    .username-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
      
      .username {
        font-size: 18px;
        font-weight: 600;
      }
      
      .right-buttons {
        display: flex;
        align-items: center;
        gap: 8px;
        
        .settings-btn {
          display: flex;
          align-items: center;
         background-color: hsl(0deg 0% 0% / 21%);
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 12px;
          cursor: pointer;
          
          .settings-icon {
            width: 13px;
            height: 13px;
            margin-right: 3px;
          }
        }
        
        .message-icon {
          width: 18px;
          height: 18px;
        }
      }
    }
    
    .days {
      font-size: 12px;
      opacity: 0.9;
    }
  }
}

// VIP等级区域
.balance-section {
  padding: 25px;
  background-color: #054dc4;
  color: white;
  
  .balance-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    
    .balance-label {
    font-size: 14px;
    opacity: .9;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    position: relative;
    left: 20px;
    position: absolute;
    font-size: px;
    -webkit-transform-origin: left top;
    transform-origin: left top;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;
    }
    
    .balance-amount {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      justify-content: flex-start;
      position: relative;
      left: 80px;
      position: absolute;
   
    font-size: px;
    transform-origin: left top;
    transform: scale(1);
    backface-visibility: hidden;
    will-change: transform;
      
      span {
        font-size: 16px;
        
      }
      
      .refresh-icon {
        width: 16px;
        height: 16px;
        margin-left: 6px;
        cursor: pointer;
        
        &.rotate {
          animation: rotate 1s linear infinite;
        }
      }
    }
  }
  
  .balance-buttons {
    display: flex;
    left: 159px;
    will-change: transform;
    backface-visibility: hidden;
    transform: scale(1);
    transform-origin: left top;
    position: absolute;
    justify-content: flex-start;
    align-items: center;
    display: flex;
    padding: 0px;
    top: 5.9em;
    flex-wrap: nowrap;
    
    button {
      flex: 1;
      padding: 10px;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      
      
      .btn-icon {
        width: 32px;
        height: 28px;
      }
      
      &.deposit-btn {
        background-color: #054dc4;
        color: white;
        
      }
      
      &.withdraw-btn {
        background-color: #054dc4;
        color: white;
      }
    }
  }
}

// VIP等级区域
.vip-section {
margin: -15px 0 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .1);
    background-image: url(https://pph5.baijin.xyz/assets/mine-vip-background-DOPhuAkg.png);
    background-size: cover;
    height: 2.07729rem;
    padding-top: 0.33816rem;
    background-repeat: no-repeat;
	border-radius: 18px 18px 0 0;
  
  .vip-info {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 15px;
    align-content: stretch;
    flex-wrap: nowrap;
    padding-left: 20px;
    
    .vip-level {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin-bottom: 0;
      margin-right: 30px;
    }
    
    .vip-progress-text {
      font-size: 12px;
      color: #999;
    }
  }
  
  .vip-progress {
    margin-bottom: 15px;
    
    .vip-progress-bar {
      width: 100%;
      height: 3px;
      background-color: #f0f0f0;
      border-radius: 3px;
      overflow: hidden;
      
      .vip-progress-fill {
        height: 100%;
        background-color: #ff6b6b;
        border-radius: 3px;
      }
    }
  }
  
  .vip-tabs {
    display: flex;
    justify-content: space-between;
    
    .vip-tab {
      flex: 1;
      text-align: center;
      font-size: 12px;
      color: #666;
      
      border-bottom: 2px solid transparent;
      
      &:hover {
        color: #4a90e2;
        border-bottom-color: #4a90e2;
      }
    }
  }
}

// 功能按钮区
.function-section {
  padding: 0 15px;
  margin-bottom: 15px;
  
  .function-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    
    .function-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      
      padding: 20px 10px;
      border-radius: 8px;
     
      
      .function-icon {
        width: 40px;
        height: 40px;
        margin-bottom: 10px;
      }
      
      span {
        font-size: 12px;
        color: #333;
      }
    }
  }
}

// 新人福利中心
.welfare-section {
      margin: 0 18px 12px;
  background-image: url('https://pph5.baijin.xyz/assets/mine-new-member-banner-0o8020v_.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  cursor: pointer;
  
  .welfare-content {
    display: flex;
    align-items: center;
    padding: 20px;
    
    .welfare-text {
      flex: 1;
      
      .welfare-title {
        font-size: 14px;
        font-weight: 600;
        color: white;
        margin-bottom: 5px;
      }
      
      .welfare-subtitle {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    
    .welfare-button {
      padding: 8px 12px;
      border-radius: 12px;
      font-size: 12px;
      white-space: nowrap;
    }
  }
  
  @media (max-width: 768px) {
    .welfare-content {
      padding: 15px;
    }
    
    .welfare-text .welfare-title {
      font-size: 12px;
    }
    
    .welfare-text .welfare-subtitle {
      font-size: 10px;
    }
    
    .welfare-button {
      padding: 6px 10px;
      font-size: 10px;
    }
  }
}

// 底部菜单
.bottom-menu {

  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  
  .menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
    
    &:last-child {
      border-bottom: none;
    }
    
    .menu-icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    
    span {
      font-size: 14px;
      color: #333;
      flex: 1;
    }
    
    .menu-arrow {
      width: 10px;
      height: 10px;
    }
  }
}

// 动画
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mode/mine.vue